const notificationAPI = '/api/notification'

const templateAPI = `${notificationAPI}/templates`

export { templateAPI }
